module.exports = __webpack_public_path__ + "media/img/corporate/logo-credit-cba08c27e7401a4f5038b61c8f45670a.svg";